export type LogLevel = "debug" | "info" | "warn" | "error";

export type LogContext = unknown;

export type Logger = {
  debug: (message: string, context?: LogContext) => void;
  info: (message: string, context?: LogContext) => void;
  warn: (message: string, context?: LogContext) => void;
  error: (message: string, context?: LogContext) => void;
  child: (scope: string) => Logger;
};

class ConsoleLogger implements Logger {
  constructor(private readonly scope: string) {}

  debug(message: string, context?: LogContext): void {
    // 디버그 로그는 개발 빌드에서만 남겨 운영 콘솔 소음을 줄인다.
    if (!import.meta.env.DEV) {
      return;
    }
    writeLog("debug", this.scope, message, context);
  }

  info(message: string, context?: LogContext): void {
    writeLog("info", this.scope, message, context);
  }

  warn(message: string, context?: LogContext): void {
    writeLog("warn", this.scope, message, context);
  }

  error(message: string, context?: LogContext): void {
    writeLog("error", this.scope, message, context);
  }

  child(scope: string): Logger {
    return new ConsoleLogger(`${this.scope}/${scope}`);
  }
}

export function createLogger(scope: string): Logger {
  return new ConsoleLogger(scope);
}

function writeLog(level: LogLevel, scope: string, message: string, context?: LogContext): void {
  // 실제 console 호출은 이 함수로 모아 앱 코드가 Logger만 의존하게 한다.
  const prefix = `[${scope}] ${message}`;

  if (context === undefined) {
    console[level](prefix);
    return;
  }

  console[level](prefix, context);
}
